import { render, staticRenderFns } from "./CraftCategoryMaterialList.vue?vue&type=template&id=0ce2e61c&scoped=true"
import script from "./CraftCategoryMaterialList.vue?vue&type=script&lang=js"
export * from "./CraftCategoryMaterialList.vue?vue&type=script&lang=js"
import style0 from "./CraftCategoryMaterialList.vue?vue&type=style&index=0&id=0ce2e61c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2e61c",
  null
  
)

export default component.exports